import { BlockLike } from "typescript";
import { FillFormTypes } from "../enums";
import { SelectListItem } from "./select-list-item";

export class SendFormToTherapistModel {
    CustomerID:number;
    FormID:number;
    TherapistID:number; // userID
    BranchID:number;
    FillType: FillFormTypes;
    NotifyBySMS: boolean;
    NotifyByEmail: boolean;
    NotifyByWhatsapp: boolean;
    CanSendEmail: boolean;
    CanSendSms: boolean;
   

    constructor(obj?: any){
        this.CustomerID = obj && obj.CustomerID || 0;
        this.FormID = obj && obj.FormID || 0;
        this.TherapistID = obj && obj.TherapistID || 0;
        this.BranchID = obj && obj.BranchID || 0;
        this.FillType = obj && obj.FillType || FillFormTypes.FillInPatientCard;
        this.NotifyBySMS = obj && obj.NotifyBySMS || false;
        this.NotifyByEmail = obj && obj.NotifyByEmail || false;
        this.NotifyByWhatsapp = obj && obj.NotifyByWhatsapp || false;
        this.CanSendEmail = obj && obj.CanSendEmail || false;
        this.CanSendSms = obj && obj.CanSendSms || false;
        
    }
}